var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 68,
    viewBox: "0 0 65 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ri:search-line",
    filter: "url(#filter0_d_135_1066)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M28.9583 4.08337C42.1373 4.08338 52.8328 14.7786 52.8333 27.9574L52.8285 28.4642C52.7301 33.4032 51.0939 38.1847 48.1556 42.1478L58.4222 52.4115L59.1292 53.1185L54.1185 58.1293L53.4115 57.4222L43.1478 47.1556C39.0495 50.1941 34.076 51.8394 28.9583 51.8324V51.8334C15.7791 51.8334 5.08334 41.1377 5.08334 27.9584C5.08334 14.7791 15.7791 4.08337 28.9583 4.08337ZM28.9583 11.1664C19.682 11.1664 12.1664 18.682 12.1664 27.9584C12.1664 37.2347 19.682 44.7504 28.9583 44.7504H28.9593L29.3685 44.7455C33.5869 44.6485 37.6189 42.9611 40.6517 40.0131L41.0228 39.642C44.0599 36.5124 45.7564 32.3207 45.7503 27.9594V27.9584L45.7445 27.5248C45.5146 18.449 38.0897 11.1664 28.9583 11.1664Z",
    fill: "white",
    stroke: "#D49D37",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_135_1066",
    x: -3,
    y: 0,
    width: 69,
    height: 69,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_135_1066"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_135_1066",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchLine);
export default __webpack_public_path__ + "static/media/search-line.277f1c25f4e6477ed0060fd44ce3bb28.svg";
export { ForwardRef as ReactComponent };